<template>
  <div >
    <video id="videobox"
           class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9" controls   >
      <source id="sourceBox" :src="videoSrc" type="application/x-mpegURL">
      <p class="vjs-no-js">不支持播放</p>
    </video>
  </div>
</template>

<script>
  import videojs from 'video.js';
  import 'video.js/dist/video-js.css';
  export default {
    name: '',
    data() {
      return {
        videoSrc:'https://ccm2cdn.open.com.cn/testyf/VE/DATA/2020/0923/VEfwnnaDATA20200923142153767.mp4?Expires=1600928517&OSSAccessKeyId=81kgc0VJPbZ4WnpN&Signature=HV6zkPj4vOOc35mp8M4PftCA5uM%3D',
        posterSrc:'',
      };
    },
    mounted() {

      setTimeout(() => {   //延时确保能监听到视频源错误
        let myPlayer = videojs("videobox", {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,
          //自动播放属性,muted:静音播放
          autoplay: "muted",
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto",
          //设置视频播放器的显示宽度（以像素为单位）
          width: "800px",
          //设置视频播放器的显示高度（以像素为单位）
          height: "400px"
        });
      },1000);

      // player.width(this.videoW)   //设置播放器宽度
    },
  };
</script>

<style scoped>

</style>